import { RawTransactionDeletion } from "./transactionDeletion.types";

export class TransactionDeletion {
  readonly id: string;
  readonly fileName: string;
  readonly totalTransactions: number;
  readonly status: string;
  readonly requestDate: string;
  readonly requestedByUserEmail: string;

  constructor(data: RawTransactionDeletion) {
    this.id = data.id;
    this.fileName = data.fileName;
    this.totalTransactions = data.totalTransactions;
    this.status = data.status;
    this.requestDate = data.requestDate;
    this.requestedByUserEmail = data.requestedByUserEmail;
  }
}


